
let env = 'test'
if (window.location.host.match('iquanwai.com')) {
  env = 'prod'
} else if (window.location.host.match('iquanwai.mobi')) {
  env = 'test'
} else if (window.location.host.match('iquanwai.top')) {
  env = 'dev'
}
window.stageENV = env

export default env